import type { User } from '@/types/common';
import { router } from '@inertiajs/vue3';
import { defineStore } from 'pinia';

export const useAuthStore = defineStore('auth', () => {
  const page = usePage();
  const user = computed<User | null>(() => page.props.user);

  async function logout() {
    router.visit('/logout', {
      method: 'post',
    });
  }

  function refresh() {
    router.reload({
      only: ['user'],
    });
  }

  return {
    user,
    logout,
    refresh,
  };
});
